export class DiscountCode {
	id:number = 0;
	code:string = "";
	from:Date = new Date();
	till:Date = new Date();
	percentage:number = 5;
	uses:number = -1;

	public constructor(data?:any){
		if (!data)return;
		this.id = data.id;
		this.code = data.code;
		this.from = new Date(data.from);
		this.till = new Date(data.till);
		this.percentage = data.percentage;
		this.uses = data.uses;
	}

	getJSON(){
		return {
			id: this.id,
			code: this.code,
			from: this.from.toJSON(),
			till: this.till.toJSON(),
			percentage: this.percentage,
			uses: this.uses,
		};
	}
}